import { dropRight, filter, includes } from 'lodash/fp';

import constants from '../../../ahm-constants';

// @ts-expect-error - Automatic, Please fix when editing this file
const getCustomerMemberTypes = (scale) =>
  // @ts-expect-error - Automatic, Please fix when editing this file
  dropRight(!includes(scale, [constants.SCALE.COUPLE, constants.SCALE.FAMILY]), [
    constants.RELATIONSHIP.CLIENT,
    constants.RELATIONSHIP.SPOUSE,
  ]);

// @ts-expect-error - Automatic, Please fix when editing this file
const filterCustomerMembers = (customer) => {
  const mainMemberTypes = getCustomerMemberTypes(customer?.scale);
  return filter(({ relationship }) => includes(relationship, mainMemberTypes), customer.members);
};

export default filterCustomerMembers;
